module.exports = __webpack_public_path__ + "static/media/buy_req_help_9.4980c893.png";